import script from "./AdvertiserEarnings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertiserEarnings.vue?vue&type=script&setup=true&lang=js"

import "./AdvertiserEarnings.vue?vue&type=style&index=0&id=1073e314&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1073e314"]])

export default __exports__